import React from 'react';
import { PLAN_LIMITS } from '../../../constants/layout';

interface SidebarCreditsBoxProps {
  credits: number;
  planName: string;
  isCollapsed: boolean;
  onOpenBilling: () => void;
}

export const SidebarCreditsBox: React.FC<SidebarCreditsBoxProps> = ({
  credits,
  planName,
  isCollapsed,
  onOpenBilling,
}) => {
  const totalCredits = PLAN_LIMITS[planName] || 100;
  const remainingPercentage = Math.min(100, totalCredits > 0 ? (credits / totalCredits) * 100 : 0);

  const getProgressColor = () => {
    if (remainingPercentage > 20) return 'bg-neutral-400';
    if (remainingPercentage > 5) return 'bg-warning-500';
    return 'bg-error-500';
  };

  if (isCollapsed) {
    return (
      <div className="px-2 mt-1">
        <button
          className="w-full flex items-center justify-center p-2.5 rounded-lg transition hover:bg-neutral-200"
          onClick={onOpenBilling}
          title="Credits"
        >
          <span className="text-xs font-medium text-neutral-500">
            {credits.toLocaleString()}
          </span>
        </button>
      </div>
    );
  }

  return (
    <button
      className="mx-3 mt-3 mb-2 p-3 rounded-lg bg-neutral-200/70 hover:bg-neutral-200 transition text-left w-[calc(100%-24px)]"
      onClick={onOpenBilling}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-2xs font-medium text-neutral-400 uppercase tracking-wide">
          Credits
        </span>
        <span className="text-2xs text-neutral-500">
          {planName}
        </span>
      </div>
      <div className="flex items-baseline gap-1.5 mb-2">
        <span className="text-lg font-medium text-neutral-800">
          {credits.toLocaleString()}
        </span>
        <span className="text-13 text-neutral-500">
          / {totalCredits.toLocaleString()}
        </span>
      </div>
      <div className="h-1 rounded-full overflow-hidden bg-neutral-200">
        <div
          className={`h-full rounded-full transition-all duration-300 ${getProgressColor()}`}
          style={{ width: `${Math.max(0, remainingPercentage)}%` }}
        />
      </div>
    </button>
  );
};
